/**
 * audienceApi — Analytics Audiences data layer (FEAT-ANALYTICS-002). RRS CRUD +
 * live estimate + the "create campaign audience" bridge. Uses the portal axios +
 * getApiHeaders convention (x-api-key + x-access-token), like the rest of Analytics.
 */
import axios from 'axios';
import { getApiHeaders } from '../../../utils/DefaultFunction';

const BASE = process.env.REACT_APP_API_URL || '';
const h = () => ({ headers: getApiHeaders(), timeout: 90000 });

export async function estimateAudience(definition) {
  const r = await axios.post(`${BASE}/analytics/audience/estimate`, { definition }, h());
  return Number(r.data?.estimated_users || 0);
}
export async function listAudiences() {
  const r = await axios.get(`${BASE}/analytics/audiences`, h());
  return r.data?.audiences || [];
}
/** Existing xNotify Cohorts/Segments — for the audience builder's "Segments" picker. */
export async function listSegments() {
  try {
    const r = await axios.get(`${BASE}/cohorts`, { params: { limit: 500 }, ...h() });
    const cohorts = r.data?.data?.cohorts || r.data?.cohorts || [];
    return cohorts.map((c) => ({ id: String(c._id || c.id), name: c.name, count: c.user_count }));
  } catch (_) { return []; }
}
/** GA "Audiences" report: Total + per-audience metrics & series over the window. */
export async function fetchAudienceReport(params = {}) {
  const r = await axios.get(`${BASE}/analytics/audiences/report`, { params, ...h() });
  return r.data || {};
}
export async function createAudience(payload) {
  const r = await axios.post(`${BASE}/analytics/audiences`, payload, h());
  return r.data;
}
export async function updateAudience(id, payload) {
  const r = await axios.put(`${BASE}/analytics/audiences/${id}`, payload, h());
  return r.data;
}
export async function deleteAudience(id) {
  const r = await axios.delete(`${BASE}/analytics/audiences/${id}`, h());
  return r.data;
}
export async function audienceToCampaign(id) {
  const r = await axios.post(`${BASE}/analytics/audiences/${id}/to-campaign`, {}, h());
  return r.data;
}
